import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import '@fontsource-variable/hanken-grotesk';
import '@fontsource-variable/jetbrains-mono';
import './estilos.css';
import './i18n';
import { LimiteErro } from '../../web/src/componentes/limite-erro';
import { ProvedorToast } from '../../web/src/componentes/toast';
import { ErroRequisicao } from '../../web/src/nucleo/api';
import { App } from './App';
import { instalarVigiaDeFoco, registrarAtividadeDoVigia } from '../../web/src/nucleo/vigia-foco';
import { registrarServiceWorker } from './push';

const qc = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 15_000,
      refetchOnWindowFocus: true,
      retry: (n, e) => !(e instanceof ErroRequisicao && e.status < 500) && n < 2,
    },
  },
});

// PWA: service worker próprio do portal (push e clique na notificação; sem cache de página).
registrarServiceWorker();
// Review r31 visual: o foco que cai no body quando o botão some ou se desabilita volta para perto de onde estava.
instalarVigiaDeFoco();
// Review r34 (robustez M1): o vigia só espera o botão desabilitado voltar com requisição em curso.
registrarAtividadeDoVigia(() => qc.isMutating() + qc.isFetching() > 0);

createRoot(document.getElementById('raiz')!).render(
  <StrictMode>
    <QueryClientProvider client={qc}>
      <BrowserRouter>
        <ProvedorToast>
          <LimiteErro>
            <App />
          </LimiteErro>
        </ProvedorToast>
      </BrowserRouter>
    </QueryClientProvider>
  </StrictMode>,
);
